// src/pages/admin/RolesPage.jsx
import React, { useState, useEffect } from 'react';
import { Box } from '@mui/material';

// Import components
import RolesList from '../../components/roles/RolesList';
import RoleAssignmentDialog from '../../components/roles/RoleAssignmentDialog';
import PageHeader from '../../components/ui/PageHeader';
import useRoleStore from '../../stores/roleStore';
import useNotificationStore from '../../stores/notificationStore';

// Import stores

/**
 * Page for role management
 */
const RolesPage = () => {
  const [assignDialogOpen, setAssignDialogOpen] = useState(false);
  const [selectedRoleId, setSelectedRoleId] = useState(null);
  const { 
    roles, 
    loading, 
    pagination, 
    error, 
    fetchRoles, 
    deleteRole 
  } = useRoleStore();
  const { showSuccess, showError } = useNotificationStore();
  
  // Load roles when component mounts
  useEffect(() => {
    fetchRoles(pagination.page, pagination.limit);
  }, [fetchRoles, pagination.page, pagination.limit]);
  
  // Handle pagination change
  const handlePageChange = (newPage) => {
    fetchRoles(newPage, pagination.limit);
  };
  
  // Handle limit change
  const handleLimitChange = (newLimit) => {
    fetchRoles(1, newLimit);
  };
  
  // Handle role deletion
  const handleDeleteRole = async (roleId) => {
    try {
      await deleteRole(roleId);
      showSuccess('Role deleted successfully');
    } catch (err) {
      showError(err.message || 'Failed to delete role');
    }
  };
  
  // Handle role refresh
  const handleRefresh = () => {
    fetchRoles(pagination.page, pagination.limit);
  };
  
  // Handle assigning role
  const handleAssign = (roleId) => {
    setSelectedRoleId(roleId);
    setAssignDialogOpen(true);
  };
  
  // Handle close assign dialog
  const handleCloseAssignDialog = () => {
    setAssignDialogOpen(false);
    setSelectedRoleId(null);
  };
  
  return (
    <Box>
      <PageHeader
        title="Roles Management"
        subtitle="Create and manage roles to control access permissions"
        icon="security"
      />
      
      <Box sx={{ mt: 3 }}>
        <RolesList
          roles={roles}
          loading={loading}
          pagination={pagination}
          onPageChange={handlePageChange}
          onLimitChange={handleLimitChange}
          onDelete={handleDeleteRole}
          onRefresh={handleRefresh}
          onAssign={handleAssign}
        />
      </Box>
      
      <RoleAssignmentDialog
        open={assignDialogOpen}
        onClose={handleCloseAssignDialog}
        roleId={selectedRoleId}
      />
    </Box>
  );
};

export default RolesPage;